import { render, staticRenderFns } from "./CommodityPDerivatives.vue?vue&type=template&id=61994b17&"
import script from "./CommodityPDerivatives.vue?vue&type=script&lang=js&"
export * from "./CommodityPDerivatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports